import axios from 'axios';
import config from './apiConfig';

const queryActivities = (activityID = '') => {

	const activityIDParam = activityID ? "/" + activityID : "";
	var headers = {'Authorization': "Bearer " + localStorage.getItem("unfAccessToken")};

	return new Promise(function(resolve, reject) {
		axios({
		    method: 'GET',
		    url: config.baseUrl + '/api/1.1/activity' + activityIDParam,
		    headers:headers,
		})
		.then(function (response) {
		    resolve(response.data);
		})
		.catch(function (error) {
		    console.log(error);
		    reject(error);
		});
	});

}

export { queryActivities };
